<template>
  <div class="thumbnail-container" @click="openFullImage">
    <img :src="url" :alt="'Thumbnail'" :style="thumbnailStyle" />
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  url: {
    type: String,
    required: true
  },
  maxWidth: {
    type: String,
    default: ''
  },
  maxHeight: {
    type: String,
    default: ''
  }
});

const thumbnailStyle = ref({
  maxWidth: props.maxWidth,
  maxHeight: props.maxHeight,
  cursor: 'pointer'
});

const openFullImage = () => {
  const newWindow = window.open(props.url, '_blank');
  if (newWindow) {
    newWindow.focus();
  }
};
</script>

<style>
@import '@/styles/image-thumbnail.css';
</style>
